<div class="modal-body">
  @if (isLoading) {
    <div class="nz-spin-h mt-3 mb-3">
      <nz-spin [nzTip]="'Loading data...'"></nz-spin>
    </div>
  }

  @if (soraData) {
    <!-- SORA Header -->
    <div class="sora-header">
      <h5>{{ soraData?.title }}</h5>

      <h6>{{ soraData?.description }}</h6>

      <span class="pdf-download-icon" (click)="onDownloadPDF()">
        <img ngSrc="./assets/images/icons/pdf-ico.svg" width="26" height="26" alt="PDF" title="PDF"/>
      </span>
    </div>

    <!-- SORA Body -->
    <div class="sora-body">
      <div class="sora-body-table">
        <table class="table">
          <tbody>
          <tr>
            <td class="border-0 width-140">SIL:</td>
            <td class="border-0">
              <span
                [ngClass]="{
                'sil': soraData?.sil !== null,
                'sil-yellow': [0].indexOf(soraData?.sil) !== -1,
                'sil-orange': [1, 2, 3, 4].indexOf(soraData?.sil) !== -1
              }">{{ soraData?.sil ?? "-" }}</span>
            </td>
          </tr>
          <tr>
            <td class="border-0 width-140">SIF Response Time:</td>
            <td class="border-0">{{ soraData?.sif_response_time ?? "-" }} s</td>
          </tr>
          <tr>
            <td class="border-0 width-140">Process Safety Time:</td>
            <td class="border-0">{{ soraData?.process_safety_time ?? "-" }} s</td>
          </tr>
          <tr>
            <td class="border-0 width-140">Shutdown Level:</td>
            <td class="border-0">{{ soraData?.sdl ?? "-" }}</td>
          </tr>
          <tr>
            <td class="border-0 width-140">Critical Final Elements:</td>
            <td class="border-0">{{ soraData?.critical_final_elements ?? "-" }}</td>
          </tr>
          </tbody>
        </table>
      </div>

      <div class="sora-body-item">
        <div class="sora-body-item-title">
          Hazardious Event Description
        </div>
        <div class="sora-body-item-content">
          <span
            [innerHTML]="soraData?.hazardous_event_description
            | normalizeNewLines
            | newLineBreaker
            | nullAsWhatever : '-'"></span>
        </div>
      </div>

      <div class="sora-body-item">
        <div class="sora-body-item-title">
          Spirious Trip Consequence
        </div>
        <div class="sora-body-item-content">
          <span
            [innerHTML]="soraData?.spirious_trip_consequence
            | normalizeNewLines
            | newLineBreaker
            | nullAsWhatever : '-'"></span>
        </div>
      </div>

      <div class="sora-body-item">
        <div class="sora-body-item-title">
          Override Risk Description
        </div>
        <div class="sora-body-item-content">
          <span
            [innerHTML]="soraData?.override_risk_description
            | normalizeNewLines
            | newLineBreaker
            | nullAsWhatever : '-'"></span>
        </div>
      </div>

      <div class="sora-body-item">
        <div class="sora-body-item-title">
          Override Request Justification
        </div>
        <div class="sora-body-item-content">
          <span
            [innerHTML]="soraData?.override_request_justification
            | normalizeNewLines
            | newLineBreaker
            | nullAsWhatever : '-'"></span>
        </div>
      </div>

      <div class="sora-body-item">
        <div class="sora-body-item-title">
          Compensating Measures
        </div>
        <div class="sora-body-item-content">
          <span
            [innerHTML]="soraData?.compensating_measures
            | normalizeNewLines
            | newLineBreaker
            | nullAsWhatever : '-'"></span>
        </div>
      </div>

      <div class="sora-body-item">
        <div class="sora-body-item-title">
          Override Duration
        </div>
        <div class="sora-body-item-content">
          <span
            [innerHTML]="soraData?.override_duration
            | normalizeNewLines
            | newLineBreaker
            | nullAsWhatever : '-'"></span>
        </div>
      </div>

      <div class="sora-body-item">
        <div class="sora-body-item-title">
          Observations
        </div>
        <div class="sora-body-item-content">
          <span
            [innerHTML]="soraData?.observations
            | normalizeNewLines
            | newLineBreaker
            | nullAsWhatever : '-'"></span>
        </div>
      </div>

    </div>
  }
</div>
